import { render, staticRenderFns } from "./CompareHistoryDetail.vue?vue&type=template&id=767c2d01"
import script from "./CompareHistoryDetail.vue?vue&type=script&lang=js"
export * from "./CompareHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./CompareHistoryDetail.vue?vue&type=style&index=0&id=767c2d01&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports